<template>
  <div :class="{ 'hero-container': true }">
    <div
      :class="{
        'post-header relative mb-10': true,
      }"
    >
      <PtcPicture
        v-if="backgroundImg.asset"
        provider="sanity"
        format="webp"
        :src="backgroundImg.asset._ref"
        :alt="heroImage?.asset?.altText ?? 'Blog Hero Image'"
        :modifiers="{
          crop: backgroundImg.crop,
          hotspot: backgroundImg.hotspot,
        }"
        :img-attrs="{
          class: 'post-image lg:h-700px md:h-[27.625rem] h-64 object-cover object-center w-full',
        }"
        :loading="'eager'"
        :preload="true"
      />
      <div
        :class="{
          'post-meta z-[2] md:absolute md:bottom-[9.75rem] md:left-[17%] md:w-13/20': true,
          'w-full px-10 pb-16 pt-8 md:p-0': true,
          'bg-www-color-white md:bg-www-color-transparent': true,
          relative: true,
        }"
      >
        <div
          v-if="date"
          :class="{
            'post-date mb-2 text-xs': true,
            'text-www-color-neutral-dark md:text-www-color-white': true,
          }"
        >
          {{ formatDateUTC(date, 'MM/DD/YYYY') }}<br />
          <!-- Will Active it later -->
          <a
            v-for="(taxonomy, index) in taxonomies"
            :key="index"
            :href="linkToResourceCenter({ slug: taxonomy.slug.current, contentType: 'blog' })"
            :class="{
              'mr-1 text-www-color-white hover:underline': true,
            }"
            >{{ taxonomy.prefLabel }}<span v-if="index !== taxonomies.length - 1">,</span>
          </a>
        </div>
        <h1
          :class="{
            'post-title mb-4 text-2xl font-medium md:mb-4 lg:mb-7 lg:text-5xl lg:leading-[3.5rem]': true,
            'text-www-color-neutral-dark md:text-www-color-white': true,
          }"
        >
          {{ title }}
        </h1>

        <a
          v-if="person?.reference?.name"
          href="#"
          :class="{
            'post-author grid w-fit items-center gap-1 text-www-color-primary-light hover:underline md:gap-x-8px': true,
          }"
        >
          <PtcPicture
            v-if="person.reference.headshot?.asset?._ref"
            provider="sanity"
            :src="person.reference.headshot.asset._ref"
            alt="author image"
            :class="{
              'post-author-thumb h-30 w-30 overflow-hidden rounded-full border border-solid border-www-color-white object-cover object-center': true,
            }"
          />

          <div
            :class="{
              'post-author-name text-xs': true,
              'text-www-color-neutral-dark md:text-www-color-white': true,
            }"
          >
            {{ person.reference.name }}
          </div></a
        >
      </div>
      <div
        :class="{
          'post-read lg:min-w-none absolute bottom-0 right-0 z-[2] flex min-w-[5.6875rem] items-center justify-center gap-10px md:left-0 md:right-auto lg:min-w-[17%] lg:justify-start': true,
          'p-14px lg:px-[1.875rem] lg:py-6': true,
          'text-center text-8px md:text-start md:text-sm': true,
          'bg-www-color-neutral-off-white text-www-color-neutral-medium-dark': true,
        }"
      >
        <PtcIcon
          name="ptc-timer"
          alt="timer icon"
          :class="{
            'hidden text-4xl leading-9 md:inline-block': true,
          }"
        />
        <div
          :class="{
            'post-read-info text-left text-[0.5rem] leading-[0.625rem] text-www-color-accent-blue-dark lg:text-xs lg:leading-none': true,
          }"
        >
          <span
            :class="{
              'font-medium': true,
            }"
            >READ TIME:</span
          ><br />
          {{ readTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { QueryBlogResult } from '~/sanity/types';
type BlogHeroProps = {
  blogHero: NonNullable<QueryBlogResult>['blogHero'];
};
const props = defineProps<BlogHeroProps>();
const { backgroundImg, title, person, date, readTime, taxonomies, heroImage } = props.blogHero;
</script>

<style>
.post-header::before {
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.5));
  content: '';
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.post-author {
  grid-template-columns: 30px 1fr;
}
</style>
